module.exports = __webpack_public_path__ + "media/assets/images/sign_up-2a4646efc431fa8ca8d2f25083fa8e0b.jpg";